export enum ApplicationStatus {
  Draft = 'Draft',
  DraftConfirmed = 'DraftConfirmed',
  Payment = 'Payment',
  CheckQualification = 'CheckQualification',
  Approved = 'Approved',
  Rejected = 'Rejected',
  QASample = 'QASample',
  ManualProcessing = 'ManualProcessing',
  RequestMoreInformation = 'RequestMoreInformation',
}

export const FilterApplicationStatus = {
  New: [ApplicationStatus.Draft, ApplicationStatus.DraftConfirmed, ApplicationStatus.QASample].join(
    ','
  ),
  ReadyForPayment: [ApplicationStatus.Payment].join(','),
  Approved: [ApplicationStatus.Approved].join(','),
  Rejected: [ApplicationStatus.Rejected].join(','),
  AwaitingClarification: [ApplicationStatus.RequestMoreInformation].join(','),
  Processing: [ApplicationStatus.ManualProcessing, ApplicationStatus.CheckQualification].join(','),
};

export enum AttachmentType {
  Certificate = 'Certificate',
  NisCourse = 'NisCourse',
  Photo = 'Photo',
  Signature = 'Signature',
}

export enum RequirementType {
  DeclarationOfCompetence = 'DeclarationOfCompetence',
  NisCourse = 'NisCourse',
  GrossTonnageLessThan250 = 'GrossTonnageLessThan250',
  Dispensation = 'Dispensation',
}
